import { render } from "./Plugin.vue?vue&type=template&id=93d5c87e&scoped=true"
import script from "./Plugin.vue?vue&type=script&lang=js"
export * from "./Plugin.vue?vue&type=script&lang=js"

import "./Plugin.vue?vue&type=style&index=0&id=93d5c87e&scoped=true&lang=css"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93d5c87e"]])

export default __exports__